(() => {
  const dutchMonths = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];

  const initialize = () => {
    document.querySelectorAll('[data-cl10m-month]').forEach((element) => {
      element.textContent = dutchMonths[new Date().getMonth()];
    });

    const trackingParameters = new URLSearchParams(window.location.search);
    if (trackingParameters.size) {
      document.querySelectorAll('[data-listicle-cta]').forEach((link) => {
        const destination = new URL(link.href, window.location.origin);
        trackingParameters.forEach((value, key) => {
          if (!destination.searchParams.has(key)) destination.searchParams.set(key, value);
        });
        link.href = destination.toString();
      });
    }

    const sticky = document.querySelector('[data-cl10m-sticky]');
    const offer = document.querySelector('[data-cl10m-offer]');

    if (!sticky || !offer || sticky.dataset.cl10mBound === 'true') return;

    sticky.hidden = false;
    sticky.dataset.cl10mBound = 'true';

    const updateSticky = () => {
      if (!window.matchMedia('(max-width: 768px)').matches) {
        sticky.classList.remove('is-visible');
        return;
      }

      const offerBounds = offer.getBoundingClientRect();
      const offerVisible = offerBounds.top < window.innerHeight && offerBounds.bottom > 0;
      sticky.classList.toggle('is-visible', window.scrollY > 3000 && !offerVisible);
    };

    window.addEventListener('scroll', updateSticky, { passive: true });
    window.addEventListener('resize', updateSticky);
    updateSticky();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
